module.exports = __webpack_public_path__ + "static/media/homework-completion-screen-footer.4a13bc3c.png";